const LOADING_PRESENTATION_BUILD = "LOADING_PRESENTATION_BUILD";
const SUCCESS_PRESENTATION_BUILD = "SUCCESS_PRESENTATION_BUILD";
const ERROR_PRESENTATION_BUILD = "ERROR_PRESENTATION_BUILD";

export const PresentationBuildStatusTypes = {
  LOADING_PRESENTATION_BUILD,
  SUCCESS_PRESENTATION_BUILD,
  ERROR_PRESENTATION_BUILD
};
